import React, { useEffect, useState } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import styles from '../../styles/forms/add_timesheet_wizard/AddTimesheetForm.scss';
import Button from '../../components/Button';
import ButtonGroup from '../../components/ButtonGroup';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import { connect } from 'react-redux';
import { __ } from '../../core/utils';
import Select from '../../components/Select';
import Input from '../../components/Input';
import DateTimePicker from '../../components/DateTimePicker';
import { listPossibleLeaveParticipants } from '../../redux/actions/table/timesheets';
import { listRoles } from '../../redux/actions/table/company_roles_and_permissions';
import PeopleChooser from '../../components/PeopleChooser';
import MultiSelect from '../../components/MultiSelect';

const AddCompanyFoldersForm = (props) => {
  const [possible_users_for_entry, set_possible_users_for_entry] = useState([]);
  const [possible_roles_for_entry, set_possible_roles_for_entry] = useState([]);

  useEffect(() => {
    // listPossibleLeaveParticipants().then(({ response }) => {
    //   set_possible_users_for_entry([
    //     ..._.map(response.data, (row) => ({
    //       ...row,
    //       name: row.fullname,
    //     })),
    //   ]);
    // });

    listRoles().then(({ response }) => {
      set_possible_roles_for_entry([
        ..._.map(response.data, (row) => ({
          ...row,
          value: row.id,
          label: row.name + ' (' + row.user_count + ')',
        })),
      ]);
    });
  }, []);

  return (
    <Form className={styles.wrapper}>
      <div className={styles.form}>
        <Field
          name='name'
          component={Input}
          label={__('table.columns.company-folders.name')}
          placeholder={__('add-company-folders-form.add-name')}
        />
        {/* <Field
          name='user_ids'
          component={PeopleChooser}
          label={__('table.columns.company-folders.user')}
          searchable
          options={possible_users_for_entry}
        /> */}
        <Field
          name='role_ids'
          component={MultiSelect}
          label={__('table.columns.company-folders.role')}
          placeholder={__('add-company-folders-form.select-role')}
          searchable
          options={possible_roles_for_entry}
        />

        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={props.actions.hideAddTimesheetWizard}
          />
          <ButtonGroup>
            <Button
              lightBlue
              medium
              middleText={__('button.create')}
              spinning={props.submitting}
              onClick={() => props.submit()}
            />
          </ButtonGroup>
        </div>
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    values: getFormValues('add_company_folders.company_folders')(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      hideAddTimesheetWizard: () =>
        dispatch({
          type: 'table.company_folders/SET_TABLE_PARAMS',
          params: {
            wizard_active: undefined,
          },
        }),
    },
  };
};

export default withRouter(
  reduxForm({
    form: 'add_company_folders.company_folders',
  })(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(subscribe(Localization, 'localization')(AddCompanyFoldersForm))
  )
);
